var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-uploader',{ref:"fileUploader",attrs:{"bucket":"ncrypt-main-storage","dropzoneOptions":_vm.dropzoneOptions,"addFileText":_vm.$t('ncrypt.attachments.add_attachments')}})}
var staticRenderFns = []

export { render, staticRenderFns }